import { useState } from "react";
import { useSession } from "../utils/SessionContext";
import api from "../api/api";
import unixTimestamp from "../utils/unixTimestamp";

const useInteractiveSofa = () => {
  const { session_id, vendorUrl } = useSession();
  const [statusInteractiveSofa, setStatusInteractiveSofa] = useState(null);
  const [responseInteractiveSofa, setResponseInteractiveSofa] = useState(null);
  const [errorInteractiveSofa, setErrorInteractiveSofa] = useState(null);
  
  const getInteractiveSofa = async (x, y, yaw, width, height, room_image_hash, product_id, position_source, isEmptyRoom) => {
    const url = `/get_interactive_sofa`;
    try {
      const params = {
        session_id,
        vendor_url: vendorUrl,
        product_id,
        x,
        y, 
        width, 
        height,
        yaw,
        room_image_hash,
        position_source,
        is_empty_room: isEmptyRoom, 
      }; 
      const res = await api.post(url, null, {
        params: params
      });
      if (res.data?.sofa === undefined) {
        res.data.status = 'error';
      }
      setResponseInteractiveSofa(res.data);
      setStatusInteractiveSofa(res.data.status);
    } catch (err) {
      setErrorInteractiveSofa(err.responseInteractiveSofa ? err.responseInteractiveSofa.data : { message: err.message });
    }
  };

  return { statusInteractiveSofa, errorInteractiveSofa, getInteractiveSofa, setStatusInteractiveSofa, responseInteractiveSofa };
};

export default useInteractiveSofa;
